import request, {
  convertData,
  MutationOptions,
  useMakeMutation,
} from '@shared/innmaxLib/services'
import React from 'react'
import { useQuery, UseQueryOptions } from 'react-query'
import { useOcppTagConverter } from './ocpp.convert'
import { IOcppTag } from './ocpp.type'

export const useOcppTagList = (query?: any, options?: UseQueryOptions) => {
  const converter = useOcppTagConverter()
  const { data: _data, ...others } = useQuery(
    ['/ocpp/tag/{pageNum}/{pageSize}', query],
    {
      ...options,
    }
  )

  const dataSource = React.useMemo(() => {
    return convertData<IOcppTag>({
      field: ['data'],
      converter,
    })(_data)
  }, [_data, converter])

  return {
    ...others,
    dataSource,
    loading: others.isLoading,
  }
}

export const useOcppTagDetail = (query?: any, options?: UseQueryOptions) => {
  const converter = useOcppTagConverter()
  const { data: _data, ...others } = useQuery(['/ocpp/tag/{id}', query], {
    ...options,
    enabled: !!query?.id,
  })

  const data = React.useMemo(() => {
    return converter((_data as any)?.data)
  }, [_data, converter])

  return {
    ...others,
    data,
    loading: others.isLoading,
  }
}

export const useAddOcppTag = (options: MutationOptions = {}) => {
  return useMakeMutation(
    (values: Partial<any> = {}) =>
      request('/ocpp/tag', {
        method: 'POST',
        body: values,
      }),
    options
  )
}

export const useUpdateOcppTag = (options: MutationOptions = {}) => {
  return useMakeMutation(
    (values: Partial<any> = {}) =>
      request('/ocpp/tag/{id}', {
        method: 'PUT',
        body: values,
      }),
    options
  )
}

export const useDeleteOcppTag = (options: MutationOptions = {}) => {
  return useMakeMutation(
    (values: Partial<any> = {}) =>
      request('/ocpp/tag/{id}', {
        method: 'DELETE',
        body: values,
      }),
    options
  )
}

export const useOcppTagHistory = (query?: any, options?: UseQueryOptions) => {
  const { data, ...others } = useQuery(['/ocpp/tag/history', query], {
    ...options,
    select: (data: any) => data?.data || [],
  })

  return {
    ...others,
    data: data as { createdAt: number; tagId: string }[],
    loading: others.isLoading,
  }
}
